var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w-100",on:{"touchstart":function($event){$event.stopPropagation();},"touchmove":function($event){$event.stopPropagation();}}},[_c('ProductDetail',{attrs:{"status":_vm.tabIndex}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }